import React, { createContext, useContext } from 'react';
import { useAuth } from '../authContext';

const CompanyContext = createContext();
export const useCompany = () => useContext(CompanyContext);
export const CompanyProvider = ({ children }) => {
  const { authData, sessionStatus } = useAuth();
  const identity = sessionStatus === 'ready' ? authData?.user : null;
  return <CompanyContext.Provider value={{ companyName: identity?.companyName || '', companyLogo: identity?.companyImage || '' }}>{children}</CompanyContext.Provider>;
};
